//Componentes generales
import React, { useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserAlt,
  faPenToSquare,
  faTrash,
  faEye,
  faBracketCurlyRight,
} from "@fortawesome/free-solid-svg-icons";

const RenderRow = ({ index, style, data }) => {
  const user = data[index];

  return (
    <div style={style}>
      <article key={user.userName}>
        <div className="container-list-users">
          <li>
            <div className="container-list-item">
              <div className="list-item-icon">
                <FontAwesomeIcon icon={faUserAlt} />
              </div>
              <div className="container-list-item-each">
                <div className="label">Usuario</div>
                <div id="item-user" className="list-item-name">
                  {user.userName}
                </div>
              </div>
              <div className="container-list-item-each">
                <div className="label">Nombre</div>
                <div className="list-item">{user.fullName}</div>
              </div>
              <div className="container-list-item-each">
                <div className="label">Email</div>
                <div className="list-item">{user.email}</div>
              </div>
              <div className="container-list-item-each">
                <div className="label">Rol</div>
                {user.userType.map((itemType) => (
                  <div key={itemType._id} className="list-item-rol">
                    {itemType.descr}
                  </div>
                ))}
              </div>
              <div className="container-list-item-each">
                <div className="label">Habilitado</div>
                <input
                  type="checkbox"
                  checked={user.enabled}
                  className="list-item-check"
                  disabled
                />
              </div>
              <div className="acciones-container">
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className="icon"
                  onClick={() => data.enviarModificar(user)}
                />
                <FontAwesomeIcon
                  icon={faTrash}
                  className="icon"
                  onClick={() => data.eliminarUser(user)}
                />
                <FontAwesomeIcon
                  icon={faEye}
                  className="icon"
                  onClick={() => data.checkEstadoVisibilidad(user)}
                />
              </div>
            </div>
          </li>
        </div>
      </article>
    </div>
  );
};

export default RenderRow;
